import React from "react";

interface LinkProps {
    href: string;
    children: React.ReactNode;
}

export const Link: React.FC<LinkProps> = ({href, children}) => (
    <a href={href} target="_blank" rel="noopener noreferrer" className="text-black underline hover:text-black">
        {children}
    </a>
);
